import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Weekday } from 'src/@types/weekday';
export function useWeeklyStrategyItems() {
    const { t } = useTranslation();
    const weeklyStrategyItems = useMemo(() => [
        {
            label: t('mentorship.abbreviated_weekday.sunday'),
            value: Weekday.Sunday
        },
        {
            label: t('mentorship.abbreviated_weekday.monday'),
            value: Weekday.Monday
        },
        {
            label: t('mentorship.abbreviated_weekday.tuesday'),
            value: Weekday.Tuesday
        },
        {
            label: t('mentorship.abbreviated_weekday.wednesday'),
            value: Weekday.Wednesday
        },
        {
            label: t('mentorship.abbreviated_weekday.thursday'),
            value: Weekday.Thursday
        },
        {
            label: t('mentorship.abbreviated_weekday.friday'),
            value: Weekday.Friday
        },
        {
            label: t('mentorship.abbreviated_weekday.saturday'),
            value: Weekday.Saturday
        }
    ], [t]);
    return weeklyStrategyItems;
}
